import {
  Box,
  Button,
  Flex,
  FormLabel,
  Input,
  Select,
  FormControl,
  Text,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useBookingActions } from 'hooks/useBookingActions';
import { bookingStatus, invoiceStatus } from 'variables/general';
import { BsSearch } from 'react-icons/bs';
import { RxReset } from 'react-icons/rx';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { MdOutlinePublish } from 'react-icons/md';
import DatePickerInput from 'components/CustomDateInput/CustomDateInput';
import { totalRow } from 'state/roles-permissions';

import {
  listChannelAtom,
  listShowAtom,
  listUnitAtom,
  venueListAtom,
  zoneListAtom,
  paymentStatusListAtom,
  paymentMethodListAtom,
  listInvoiceAtom,
  showTimeListAtom,
} from '../../state/show';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import SearchTable2 from 'components/Tables/SearchTable2';
import { columnsInvoiceList } from 'variables/columnsData';
import ExportButton from 'components/Button/ExportButton';
import dayjs from 'dayjs';

function DataTableInvoice() {
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('This field is required')
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const textColor = useColorModeValue('gray.700', 'white');
  const bookingActions = useBookingActions();
  const listShow = useRecoilValue(listShowAtom);
  const listInvoice = useRecoilValue(listInvoiceAtom);
  const totalRows = useRecoilValue(totalRow);
  const venueList = useRecoilValue(venueListAtom);
  const listChannel = useRecoilValue(listChannelAtom);
  const listUnit = useRecoilValue(listUnitAtom);
  const listZone = useRecoilValue(zoneListAtom);
  const listPaymentMethod = useRecoilValue(paymentMethodListAtom);
  const showTimeList = useRecoilValue(showTimeListAtom);
  const listPaymentStatus = useRecoilValue(paymentStatusListAtom);
  const [isFetching, setIsFetching] = useState(true);
  const [newInvoiceList, setNewInvoiceList] = useState([]);
  const [isPublishInvoice, setIsPublishInvoice] = useState(false);
  const [listCheckedChoose, setListCheckedChoose] = useState([]);
  const [clearAllCheckBox, setClearAllCheckBox] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshPagingDefault, setRefreshPagingDefault] = useState(false);
  const [currentPublish, setCurrentPublish] = useState({
    code: '',
    id: '',
  });
  const [hasSearched, setHasSearched] = useState(false);
  const [isExportExcel, setIsExportExcel] = useState(false);
  const [isBulkProcessing, setIsBulkProcessing] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAllInvoice,
    onOpen: onOpenAllInvoice,
    onClose: onCloseAllInvoice,
  } = useDisclosure();
  const {
    isOpen: isOpenBulkWithInfo,
    onOpen: onOpenBulkWithInfo,
    onClose: onCloseBulkWithInfo,
  } = useDisclosure();
  const toast = useToast();

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    control: controlSearch,
    watch: watchSearch,
    reset: resetSearch,
    setValue: setValueSearch,
    formState,
  } = useForm();
  const { register, handleSubmit, reset } = useForm(formOptions);
  const { errors, isSubmitting } = formState;
  const statusSearch = watchSearch('statusSearch');
  const channelSearch = watchSearch('channelSearch');
  const bookingCodeSearch = watchSearch('bookingCodeSearch');
  const bookerNameSearch = watchSearch('bookerNameSearch');
  const unitSearch = watchSearch('unitSearch');
  const paymentMethodSearch = watchSearch('paymentMethodSearch');
  const paymentStatusSearch = watchSearch('paymentStatusSearch');
  const showTimeSearch = watchSearch('showTimeSearch');
  const zoneSearch = watchSearch('zoneSearch');
  const venueSearch = watchSearch('venueSearch');
  const showSearch = watchSearch('showSearch');
  const invoiceResponseSearch = watchSearch('invoiceResponseSearch');
  const allSearchValues = watchSearch();

  useEffect(() => {
    if (hasSearched) {
      setIsFilterDirty(true);
    }
  }, [JSON.stringify(allSearchValues)]);

  useEffect(() => {
    if (channelSearch) {
      bookingActions.getListUnits({ channel_id: channelSearch }, 0, '');
    }
  }, [channelSearch]);

  useEffect(async () => {
    setIsFetching(true);

    bookingActions.getListShow({ status: 1 }, 0, '');
    bookingActions.getListChannel({ status: 1 }, 0, '');
    bookingActions.getListVenue({ status: 1 }, 0, '');
    bookingActions.getListZones({ status: 1 }, 0, '');
    bookingActions.getListPaymentStatus({ status: 1 }, 0, '');
    bookingActions.getListPaymentMethod({ status: 1 }, 0, '');
    bookingActions.getListShowTime({ status: 1 }, 0, '');
    setValueSearch('from_showdate', new Date());
    setValueSearch('to_showdate', new Date());
    setValueSearch('paid_date_from', null);
    setValueSearch('paid_date_to', null);
    setIsFetching(false);
  }, []);
  useEffect(() => {
    if (listInvoice) {
      const newListInvoices = listInvoice.map((i) => ({
        ...i,
        typeSwitch: 'invoice',
        filters: {
          show_id: showSearch,
          venue_id: venueSearch,
          booking_code: bookingCodeSearch,
          booker_name: bookerNameSearch,
          channel_id: channelSearch,
          unit_id: unitSearch,
          payment_method: paymentMethodSearch,
          payment_status: paymentStatusSearch,
          show_time: showTimeSearch,
          zone_id: zoneSearch,
          status: statusSearch ? statusSearch : 1,
        },
      }));
      setNewInvoiceList(newListInvoices);
    }
  }, [listInvoice]);
  const recallApi = async (fetchDataOptions) => {
    setIsFetching(true);
    // Only load data if user has searched before
    if (hasSearched) {
      const show_date_from = watchSearch('from_showdate')
        ? dayjs(watchSearch('from_showdate')).format('YYYY-MM-DD')
        : undefined;
      const show_date_to = watchSearch('to_showdate')
        ? dayjs(watchSearch('to_showdate')).format('YYYY-MM-DD')
        : undefined;
      const paid_date_from = watchSearch('paid_date_from')
        ? new Date(watchSearch('paid_date_from').setHours(0, 0, 0, 0))
        : undefined;
      const paid_date_to = watchSearch('paid_date_to')
        ? new Date(watchSearch('paid_date_to').setHours(23, 59, 59, 999))
        : undefined;
      await bookingActions.getListInvoice(
        {
          show_id: showSearch,
          venue_id: venueSearch,
          booking_code: bookingCodeSearch,
          booker_name: bookerNameSearch,
          status: statusSearch,
          channel_id: channelSearch,
          unit_id: unitSearch,
          payment_method: paymentMethodSearch,
          payment_status: paymentStatusSearch,
          show_time: showTimeSearch,
          zone_id: zoneSearch,
          invoice_status: watchSearch('invoice_status'),
          invoice_response: invoiceResponseSearch,
          show_date_from: show_date_from,
          show_date_to: show_date_to,
          paid_date_from: paid_date_from,
          paid_date_to: paid_date_to,
          sort_type: fetchDataOptions.sort_type,
          sort_field: fetchDataOptions.sort_field,
        },
        fetchDataOptions.pageIndex,
        fetchDataOptions.pageSize
      );
    }
    setIsFetching(false);
  };


  async function onSubmitSearch({
    bookingCodeSearch,
    bookerNameSearch,
    showSearch,
    venueSearch,
    statusSearch,
    channelSearch,
    unitSearch,
    paymentMethodSearch,
    paymentStatusSearch,
    showTimeSearch,
    zoneSearch,
    invoice_status,
    invoiceResponseSearch,
  }) {
    const show_date_from = watchSearch('from_showdate')
      ? dayjs(watchSearch('from_showdate')).format('YYYY-MM-DD')
      : undefined;
    const show_date_to = watchSearch('to_showdate')
      ? dayjs(watchSearch('to_showdate')).format('YYYY-MM-DD')
      : undefined;
    const paid_date_from = watchSearch('paid_date_from')
      ? new Date(watchSearch('paid_date_from').setHours(0, 0, 0, 0))
      : undefined;
    const paid_date_to = watchSearch('paid_date_to')
      ? new Date(watchSearch('paid_date_to').setHours(23, 59, 59, 999))
      : undefined;

    // Validate: if no at least one complete date range is required
    const hasFullShowDate = !!(show_date_from && show_date_to);
    const hasFullPaidDate = !!(paid_date_from && paid_date_to);
    if (!hasFullShowDate && !hasFullPaidDate) {
      toast({
        description: 'Please select Date range (Show Date/Paid Date) before searching.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
      if (isExportExcel) setIsExportExcel(false);
      return;
    }

    // Validate: show date range must be either both set or both empty
    if ((show_date_from && !show_date_to) || (!show_date_from && show_date_to)) {
      toast({
        description: 'Please enter both Show Date From and Show Date To',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
      if (isExportExcel) setIsExportExcel(false);
      return;
    }

    // Validate: paid date range must be either both set or both empty
    if ((paid_date_from && !paid_date_to) || (!paid_date_from && paid_date_to)) {
      toast({
        description: 'Please enter both Paid Date From and Paid Date To',
        status: 'warning',
        duration: 4000,
        isClosable: true,
        position: 'top-right',
      });
      if (isExportExcel) setIsExportExcel(false);
      return;
    }

    if (isExportExcel) {
      setIsExportExcel(false);

      const params = {
        show_id: showSearch,
        venue_id: venueSearch,
        booking_code: bookingCodeSearch,
        booker_name: bookerNameSearch,
        status: statusSearch,
        channel_id: channelSearch,
        unit_id: unitSearch,
        payment_method: paymentMethodSearch,
        payment_status: paymentStatusSearch,
        show_time: showTimeSearch,
        zone_id: zoneSearch,
        invoice_status,
        invoice_response: invoiceResponseSearch,
        show_date_from,
        show_date_to,
        paid_date_from,
        paid_date_to,
      };
      const response =  await bookingActions.exportBookingExcel(params);
      const outputFilename = `invoice_report_${Date.now()}.xlsx`;
      const url = URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
      return;
    }

    setIsFetching(true);
    setHasSearched(true);
    setIsFilterDirty(false);
    // Reset selection when performing new search
    setListCheckedChoose([]);
    setClearAllCheckBox(prev => prev + 1);
    
    if (isPublishInvoice) {
      setIsPublishInvoice(false);
      onOpenAllInvoice();
    } else {
      await bookingActions.getListInvoice(
        {
          show_id: showSearch,
          venue_id: venueSearch,
          booking_code: bookingCodeSearch,
          booker_name: bookerNameSearch,
          status: statusSearch,
          channel_id: channelSearch,
          unit_id: unitSearch,
          payment_method: paymentMethodSearch,
          payment_status: paymentStatusSearch,
          show_time: showTimeSearch,
          zone_id: zoneSearch,
          invoice_status,
          invoice_response: invoiceResponseSearch,
          show_date_from,
          show_date_to,
          paid_date_from,
          paid_date_to,
        },
        0,
        localStorage && localStorage.getItem('currentPageSizeStore')
          ? localStorage.getItem('currentPageSizeStore')
          : 10
      );
    }
    setRefreshPagingDefault((prev) => !prev);
    setIsFetching(false);
  }

  async function onSubmit({
    company_name,
    tax_code,
    company_address,
    email,
    invoice_issuer,
  }) {
    setIsLoading(true);
    const params = {
      booking_id: currentPublish.id,
      company_name,
      tax_code,
      company_address,
      email,
      invoice_issuer: parseInt(invoice_issuer),
    };
    try {
      const res = await bookingActions.publishInvoice(params);
      if (res.status === 200) {
        onClose();
        reset();

        toast({
          description: 'Publish Invoice success',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });

        const show_date_from = watchSearch('from_showdate')
          ? dayjs(watchSearch('from_showdate')).format('YYYY-MM-DD')
          : undefined;
        const show_date_to = watchSearch('to_showdate')
          ? dayjs(watchSearch('to_showdate')).format('YYYY-MM-DD')
          : undefined;
        const paid_date_from = watchSearch('paid_date_from')
          ? new Date(watchSearch('paid_date_from').setHours(0, 0, 0, 0))
          : undefined;
        const paid_date_to = watchSearch('paid_date_to')
          ? new Date(watchSearch('paid_date_to').setHours(23, 59, 59, 999))
          : undefined;
        await bookingActions.getListInvoice(
          {
            show_id: showSearch,
            venue_id: venueSearch,
            booking_code: bookingCodeSearch,
            booker_name: bookerNameSearch,
            status: statusSearch,
            channel_id: channelSearch,
            unit_id: unitSearch,
            payment_method: paymentMethodSearch,
            payment_status: paymentStatusSearch,
            show_time: showTimeSearch,
            zone_id: zoneSearch,
            invoice_status: watchSearch('invoice_status'),
            invoice_response: invoiceResponseSearch,
            show_date_from: show_date_from,
            show_date_to: show_date_to,
            paid_date_from: paid_date_from,
            paid_date_to: paid_date_to,
          },
          0,
          localStorage && localStorage.getItem('currentPageSizeStore')
            ? localStorage.getItem('currentPageSizeStore')
            : 10
        );
      }
    } catch (err) {
      console.warn(err);
      toast({
        description:
          'Your request has been recorded and processed by VNPT. Please check the result later.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    }
    setIsLoading(false);
  }

  const publishBulk = async () => {
    setIsLoading(true);
    setIsBulkProcessing(true);
    
    // Reset UI immediately to prevent duplicate requests
    const bookingIds = [...listCheckedChoose];
    const bookingCount = bookingIds.length;
    onCloseAllInvoice();
    
    // Show processing toast
    toast({
      description: `Processing ${bookingCount} invoices. This may take a few minutes...`,
      status: 'info',
      duration: 8000,
      isClosable: true,
      position: 'top-right',
    });
    
    try {
      const res = await bookingActions.publishBulkInvoice({
        booking_ids: bookingIds.map((i) => parseInt(i)),
      });
      if (res.status === 200) {
        toast({
          description: `Successfully published ${bookingCount} invoices without info`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Bulk publish error:', error);
      toast({
        description: error.response?.status === 408 || error.code === 'ECONNABORTED' 
          ? `Bulk publish is processing in background. Please wait and refresh the page in a few minutes to see updates.`
          : 'Something went wrong with bulk publish. Please check results manually.',
        status: error.response?.status === 408 || error.code === 'ECONNABORTED' ? 'warning' : 'error',
        duration: 10000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      // Always refresh data and reset loading state
      const show_date_from = watchSearch('from_showdate')
        ? dayjs(watchSearch('from_showdate')).format('YYYY-MM-DD')
        : undefined;
      const show_date_to = watchSearch('to_showdate')
        ? dayjs(watchSearch('to_showdate')).format('YYYY-MM-DD')
        : undefined;
      const paid_date_from = watchSearch('paid_date_from')
        ? new Date(watchSearch('paid_date_from').setHours(0, 0, 0, 0))
        : undefined;
      const paid_date_to = watchSearch('paid_date_to')
        ? new Date(watchSearch('paid_date_to').setHours(23, 59, 59, 999))
        : undefined;
      
      try {
        await bookingActions.getListInvoice(
          {
            show_id: showSearch,
            venue_id: venueSearch,
            booking_code: bookingCodeSearch,
            booker_name: bookerNameSearch,
            status: statusSearch,
            channel_id: channelSearch,
            unit_id: unitSearch,
            payment_method: paymentMethodSearch,
            payment_status: paymentStatusSearch,
            show_time: showTimeSearch,
            zone_id: zoneSearch,
            invoice_status: watchSearch('invoice_status'),
            invoice_response: invoiceResponseSearch,
            show_date_from: show_date_from,
            show_date_to: show_date_to,
            paid_date_from: paid_date_from,
            paid_date_to: paid_date_to,
          },
          0,
          localStorage && localStorage.getItem('currentPageSizeStore')
            ? localStorage.getItem('currentPageSizeStore')
            : 10
        );
      } catch (refreshError) {
        console.error('Error refreshing data:', refreshError);
      }

      // Ensure clean state after refresh
      setListCheckedChoose([]);
      setClearAllCheckBox(prev => prev + 1);
      setIsLoading(false);
      setIsBulkProcessing(false);
    }
  };

  const publishBulkWithInfo = async (data) => {
    setIsLoading(true);
    setIsBulkProcessing(true);
    
    // Reset UI immediately to prevent duplicate requests
    const bookingIds = [...listCheckedChoose];
    const bookingCount = bookingIds.length;
    onCloseBulkWithInfo();
    reset();
    
    // Show processing toast
    toast({
      description: `Processing ${bookingCount} invoices with info. This may take a few minutes...`,
      status: 'info',
      duration: 8000,
      isClosable: true,
      position: 'top-right',
    });
    
    try {
      const payload = {
        booking_ids: bookingIds.map((i) => parseInt(i)),
        company_name: data.company_name,
        tax_code: data.tax_code,
        company_address: data.company_address,
        email: data.email,
        invoice_issuer: parseInt(data.invoice_issuer),
      };
      const res = await bookingActions.publishBulkInvoice(payload);
      if (res.status === 200) {
        toast({
          description: `Successfully published ${bookingCount} invoices with info`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Bulk publish with info error:', error);
      toast({
        description: error.response?.status === 408 || error.code === 'ECONNABORTED' 
          ? `Bulk publish is processing in background. Please wait and refresh the page in a few minutes to see updates.`
          : 'Something went wrong with bulk publish. Please check results manually.',
        status: error.response?.status === 408 || error.code === 'ECONNABORTED' ? 'warning' : 'error',
        duration: 10000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      // Always refresh data and reset loading state
      const show_date_from = watchSearch('from_showdate')
        ? dayjs(watchSearch('from_showdate')).format('YYYY-MM-DD')
        : undefined;
      const show_date_to = watchSearch('to_showdate')
        ? dayjs(watchSearch('to_showdate')).format('YYYY-MM-DD')
        : undefined;
      const paid_date_from = watchSearch('paid_date_from')
        ? new Date(watchSearch('paid_date_from').setHours(0, 0, 0, 0))
        : undefined;
      const paid_date_to = watchSearch('paid_date_to')
        ? new Date(watchSearch('paid_date_to').setHours(23, 59, 59, 999))
        : undefined;
      
      try {
        await bookingActions.getListInvoice(
          {
            show_id: showSearch,
            venue_id: venueSearch,
            booking_code: bookingCodeSearch,
            booker_name: bookerNameSearch,
            status: statusSearch,
            channel_id: channelSearch,
            unit_id: unitSearch,
            payment_method: paymentMethodSearch,
            payment_status: paymentStatusSearch,
            show_time: showTimeSearch,
            zone_id: zoneSearch,
            invoice_status: watchSearch('invoice_status'),
            invoice_response: invoiceResponseSearch,
            show_date_from: show_date_from,
            show_date_to: show_date_to,
            paid_date_from: paid_date_from,
            paid_date_to: paid_date_to,
          },
          0,
          localStorage && localStorage.getItem('currentPageSizeStore')
            ? localStorage.getItem('currentPageSizeStore')
            : 10
        );
      } catch (refreshError) {
        console.error('Error refreshing data:', refreshError);
      }

      // Ensure clean state after refresh
      setListCheckedChoose([]);
      setClearAllCheckBox(prev => prev + 1);
      setIsLoading(false);
      setIsBulkProcessing(false);
    }
  };
  const publishInvoice = async (val) => {
    setCurrentPublish({
      id: val.id,
      code: val.code,
    });
    onOpen();
  };
  const getValueChecked = (val) => {
    if (val) {
      const checkedIDs = Object.keys(val);
      setListCheckedChoose(checkedIDs);
    } else {
      // Clear selections when no items are checked
      setListCheckedChoose([]);
    }
  };
  return (
    <Card px='0px'>
      <CardHeader px='22px' mb='12px'>
        <Flex direction='column' display='block'>
          <Text
            float='left'
            color={textColor}
            fontSize='lg'
            fontWeight='bold'
            mb='6px'
          >
            Invoice Report 
          </Text>
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpen}
            onClose={() => {
              onClose();
              reset();
            }}
            size='2xl'
          >
            <ModalOverlay />
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalContent>
                <ModalHeader color={'green'}>
                  Publish invoice booking {currentPublish.code}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Company Name
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Company Name'
                      maxLength={250}
                      size='md'
                      name='company_name'
                      {...register('company_name')}
                      isInvalid={errors.company_name}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.company_name?.message}
                    </Text>
                  </FormControl>
                  <FormControl>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Tax Code
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Tax Code'
                      maxLength={250}
                      size='md'
                      name='tax_code'
                      {...register('tax_code')}
                      isInvalid={errors.tax_code}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.tax_code?.message}
                    </Text>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Company Address
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Company Address'
                      maxLength={250}
                      size='md'
                      name='company_address'
                      {...register('company_address')}
                      isInvalid={errors.company_address}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.company_address?.message}
                    </Text>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Email
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Email'
                      maxLength={250}
                      size='md'
                      name='email'
                      {...register('email')}
                      isInvalid={errors.email}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.email?.message}
                    </Text>
                  </FormControl>
                  <FormControl>
                    <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                      Invoice issuer
                    </FormLabel>
                    <Select
                      ms='4px'
                      type='text'
                      defaultValue='0'
                      size='sm'
                      name='invoice_issuer'
                      {...register('invoice_issuer')}
                      width='120px'
                    >
                      <option value='0'>Default</option>
                      <option value='1'>SaiGon</option>
                      <option value='2'>Hoi An</option>
                      <option value='3'>Ha Noi</option>
                    </Select>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isLoading}
                  >
                    Publish
                  </Button>
                  <Button
                    onClick={() => {
                      onClose();
                      reset();
                    }}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
          {/* Bulk publish with info modal */}
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpenBulkWithInfo}
            onClose={() => {
              onCloseBulkWithInfo();
              reset();
            }}
            size='2xl'
          >
            <ModalOverlay />
            <form onSubmit={handleSubmit(publishBulkWithInfo)}>
              <ModalContent>
                <ModalHeader color={'green'}>
                  Publish invoice bookings (with information)
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Company Name
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Company Name'
                      maxLength={250}
                      size='md'
                      name='company_name'
                      {...register('company_name')}
                      isInvalid={errors.company_name}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.company_name?.message}
                    </Text>
                  </FormControl>
                  <FormControl>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Tax Code
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Tax Code'
                      maxLength={250}
                      size='md'
                      name='tax_code'
                      {...register('tax_code')}
                      isInvalid={errors.tax_code}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.tax_code?.message}
                    </Text>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Company Address
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Company Address'
                      maxLength={250}
                      size='md'
                      name='company_address'
                      {...register('company_address')}
                      isInvalid={errors.company_address}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.company_address?.message}
                    </Text>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                      Email
                    </FormLabel>
                    <Input
                      fontSize='sm'
                      ms='4px'
                      type='text'
                      placeholder='Email'
                      size='md'
                      name='email'
                      {...register('email')}
                      isInvalid={errors.email}
                      errorBorderColor='red.300'
                    />
                    <Text color='red' fontSize={14} mb='10px' ml='5px'>
                      {errors.email?.message}
                    </Text>
                  </FormControl>
                  <FormControl>
                    <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                      Invoice issuer
                    </FormLabel>
                    <Select
                      ms='4px'
                      type='text'
                      defaultValue='0'
                      size='sm'
                      name='invoice_issuer'
                      {...register('invoice_issuer')}
                      width='120px'
                    >
                      <option value='0'>Default</option>
                      <option value='1'>SaiGon</option>
                      <option value='2'>Hoi An</option>
                      <option value='3'>Ha Noi</option>
                    </Select>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme='blue' mr={3} type='submit' isLoading={isLoading}>
                    Publish
                  </Button>
                  <Button
                    onClick={() => {
                      onCloseBulkWithInfo();
                      reset();
                    }}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpenAllInvoice}
            onClose={() => {
              onCloseAllInvoice();
              reset();
            }}
            size='2xl'
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader color={'green'}>
                Publish invoice bookings
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                Do you want to publish invoices for selected Booking(s)?
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme='blue'
                  mr={3}
                  onClick={() => publishBulk()}
                  isLoading={isLoading}
                >
                  Yes
                </Button>
                <Button
                  onClick={() => {
                    onCloseAllInvoice();
                    reset();
                  }}
                >
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <Flex ml='22px'></Flex>
        <Card>
          <form
            id='booking-search-form'
            onSubmit={handleSubmitSearch(onSubmitSearch)}
          >
            <Flex
              direction='row'
              alignItems='center'
              mb={3}
              gap={4}
              flexWrap={'wrap'}
            >
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='sm' fontWeight='semibold'>
                  Show Date From
                </FormLabel>
                <Controller
                  name='from_showdate'
                  control={controlSearch}
                  render={({ field }) => (
                    <>
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        mask='99/99/9999'
                        selected={watchSearch('from_showdate')}
                        selectsStart
                        startDate={watchSearch('from_showdate')}
                        endDate={watchSearch('to_showdate')}
                        minDate={new Date('01/01/2020')}
                      />
                      {watchSearch('to_showdate') !== null && watchSearch('from_showdate') === null && (
                          <Text color='red' fontSize='xs'>
                            Show Date From is required
                          </Text>
                        )}
                    </>
                  )}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='sm' fontWeight='semibold'>
                  Show Date To
                </FormLabel>
                <Controller
                  name='to_showdate'
                  control={controlSearch}
                  render={({ field }) => (
                    <>
                    <DatePickerInput
                      onChange={(value) => field.onChange(value)}
                      selected={field.value}
                      mask='99/99/9999'
                      selectsEnd
                      startDate={watchSearch('from_showdate')}
                      endDate={watchSearch('to_showdate')}
                      minDate={watchSearch('from_showdate') || new Date("01/01/2020")}
                    />
                    {watchSearch('from_showdate') !== null && watchSearch('to_showdate') === null && (
                          <Text color='red' fontSize='xs'>
                            Show Date From is required
                          </Text>
                        )}
                    </>

                  )}
                />
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                  Paid Date From
                </FormLabel>
                <Controller
                  name="paid_date_from"
                  control={controlSearch}
                  render={({ field }) => (
                    <>
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        mask="99/99/9999"
                        selected={watchSearch("paid_date_from")}
                        selectsStart
                        startDate={watchSearch("paid_date_from")}
                        endDate={watchSearch("paid_date_to")}
                        minDate={new Date("01/01/2020")}
                      />
                      {watchSearch("paid_date_to") !== null && watchSearch('paid_date_from') === null && (
                          <Text color='red' fontSize='xs'>
                            Paid Date To is required
                          </Text>
                        )}
                    </>
                  )}
                />
              </Box>
              <Box direction="row" alignItems="center" display="block">
                <FormLabel fontWeight="semibold" fontSize="xs" ms="4px">
                 Paid Date To
                </FormLabel>
                <Controller
                  name="paid_date_to"
                  control={controlSearch}
                  render={({ field }) => (
                    <>
                      <DatePickerInput
                        onChange={(value) => field.onChange(value)}
                        selected={watchSearch("paid_date_to")}
                        mask="99/99/9999"
                        selectsEnd
                        startDate={watchSearch("paid_date_from")}
                        endDate={watchSearch("paid_date_to")}
                        minDate={watchSearch("paid_date_from") || new Date("01/01/2020")}
                      />
                      {watchSearch("paid_date_from") !== null && watchSearch('paid_date_to') === null && (
                          <Text color='red' fontSize='xs'>
                            Paid Date From is required
                          </Text>
                        )}
                    </>
                  )}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='xs' fontWeight='semibold'>
                  E-Invoice
                </FormLabel>
                <Input
                  _placeholder={{ color: 'gray.400' }}
                  variant='main'
                  type='text'
                  placeholder='E-Invoice'
                  width='200px'
                  size='sm'
                  fontSize='sm'
                  name='invoiceResponseSearch'
                  {...registerSearch('invoiceResponseSearch')}
                  _focus={{ borderColor: 'blue.500' }}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='xs' fontWeight='semibold'>
                  Booking Code
                </FormLabel>
                <Input
                  _placeholder={{ color: 'gray.400' }}
                  variant='main'
                  type='text'
                  placeholder='Booking Code'
                  width='200px'
                  size='sm'
                  fontSize='sm'
                  name='bookingCodeSearch'
                  {...registerSearch('bookingCodeSearch')}
                  _focus={{ borderColor: 'blue.500' }}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='xs' fontWeight='semibold'>
                  Booking information,...
                </FormLabel>
                <Input
                  _placeholder={{ color: 'gray.400' }}
                  variant='main'
                  type='text'
                  placeholder='Booking information,...'
                  minW='80px'
                  maxW='185px'
                  size='sm'
                  fontSize='sm'
                  name='bookerNameSearch'
                  {...registerSearch('bookerNameSearch')}
                  _focus={{ borderColor: 'blue.500' }}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Show
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue='0'
                  size='sm'
                  id='showSearch'
                  name='showSearch'
                  {...registerSearch('showSearch')}
                  width='100px'
                >
                  <option value=''>All</option>
                  {listShow.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Venue
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  size='sm'
                  id={'venueSearch'}
                  name='venueSearch'
                  {...registerSearch('venueSearch')}
                >
                  <option value=''>All</option>
                  {venueList.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Zone
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  size='sm'
                  name='zoneSearch'
                  {...registerSearch('zoneSearch')}
                  width='200px'
                >
                  <option value=''>All</option>
                  {listZone.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Channel
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  size='sm'
                  name='channelSearch'
                  {...registerSearch('channelSearch')}
                  width='200px'
                >
                  <option value=''>All</option>
                  {listChannel.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.name}
                    </option>
                  ))}
                </Select>
              </Box>
              {channelSearch && (
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Unit
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    id='unit_search'
                    name='unitSearch'
                    {...registerSearch('unitSearch')}
                  >
                    <option value=''>All</option>
                    {listUnit.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                  </Select>
                </Box>
              )}
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Show Time
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue=''
                  size='sm'
                  name='showTimeSearch'
                  {...registerSearch('showTimeSearch')}
                >
                  <option value=''>All</option>
                  {showTimeList.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Booking Status
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue='0'
                  size='sm'
                  id='statusSearch'
                  name='statusSearch'
                  {...registerSearch('statusSearch')}
                  width='100px'
                >
                  {bookingStatus.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Invoice Status
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue='0'
                  size='sm'
                  name='invoice_status'
                  {...registerSearch('invoice_status')}
                  width='100px'
                >
                  {invoiceStatus.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Payment Method
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  placeholder=''
                  size='sm'
                  name='paymentMethodSearch'
                  {...registerSearch('paymentMethodSearch')}
                >
                  <option value=''>All</option>
                  {listPaymentMethod.map((item, index) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel
                  htmlFor='role-search-lbl'
                  fontWeight='semibold'
                  fontSize='xs'
                  ms='4px'
                >
                  Payment Status
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue=''
                  size='sm'
                  name='paymentStatusSearch'
                  {...registerSearch('paymentStatusSearch')}
                  width='100px'
                >
                  <option value=''>All</option>
                  {listPaymentStatus.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Box>
            </Flex>
            <Text color='red' fontSize={14}>
              {Object.values(errors)[0]?.message}
            </Text>
            <Flex justify='center' align='center' gap={{ base: "4px", md: "8px" }} mt={3} flexWrap="wrap">
              <Box direction='row' alignItems='center' display='block'>
                <Button
                  leftIcon={<RxReset />}
                  variant='primary'
                  w={{ base: "70px", md: "88px" }}
                  h='33px'
                  fontSize={{ base: "sm", md: "md" }}
                  onClick={() => {
                    resetSearch();
                    setValueSearch('from_showdate', new Date());
                    setValueSearch('to_showdate', new Date());
                    setValueSearch('paid_date_from', null);
                    setValueSearch('paid_date_to', null);
                    // Reset selection when resetting search
                    setListCheckedChoose([]);
                    setClearAllCheckBox(prev => prev + 1);
                  }}
                >
                  Reset
                </Button>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <Button
                  leftIcon={<RiFileExcel2Fill />}
                  variant='primary'
                  w={{ base: "80px", md: "100px" }}
                  h='33px'
                  fontSize={{ base: "sm", md: "md" }}
                  isDisabled={newInvoiceList.length === 0 || isFilterDirty}
                  onClick={() => {
                    setIsExportExcel(true);
                  }}
                  type='submit'
                >
                  <Text display={{ base: "none", md: "block" }}>Export Excel</Text>
                  <Text display={{ base: "block", md: "none" }}>Export</Text>
                </Button>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <Button
                  leftIcon={<BsSearch />}
                  variant='primary'
                  w={{ base: "70px", md: "88px" }}
                  h='33px'
                  fontSize={{ base: "sm", md: "md" }}
                  type='submit'
                >
                  Search
                </Button>
              </Box>
              <Box direction='row' alignItems='center' display='block' ml={{ base: "4px", md: "16px" }}>
                <Menu>
                  <MenuButton
                    as={Button}
                    type='button'
                    leftIcon={<MdOutlinePublish />}
                    colorScheme='teal'
                    h='33px'
                    fontSize={{ base: "sm", md: "md" }}
                    px={{ base: "12px", md: "16px" }}
                    isDisabled={listCheckedChoose.length < 1 || isBulkProcessing}
                  >
                    <Text display={{ base: "none", md: "block" }}>{isBulkProcessing ? 'Processing...' : 'Publish Invoice'}</Text>
                    <Text display={{ base: "block", md: "none" }}>{isBulkProcessing ? 'Processing...' : 'Publish'}</Text>
                  </MenuButton>
                  <MenuList zIndex={2000}>
                    <MenuItem
                      onClick={() => {
                        // publish without info: open confirm modal
                        onOpenAllInvoice();
                      }}
                    >
                      Publish without information
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        // publish with info: open bulk-with-info form
                        onOpenBulkWithInfo();
                      }}
                    >
                      Publish with information
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Box>
            </Flex>
          </form>
        </Card>
        <div className="header-blue-600">
          <SearchTable2
            tableData={newInvoiceList}
            columnsData={columnsInvoiceList}
            totalRow={totalRows.invoice}
            listPermissions={[69]}
            actionsActive={isBulkProcessing ? [] : ['publish']}
            loadData={(fetchDataOptions) => recallApi(fetchDataOptions)}
            isFetching={isFetching}
            publishRow={(item) => publishInvoice(item)}
            enableRowSelection
            updateCheckbox={(val) => getValueChecked(val)}
            conditionShowSelect={`(row) => row.original.invoice_status === 0 && row.original.payment_type !== 3 && row.original.status === 1`}
            clearAllCheckBox={clearAllCheckBox}
            refreshPagingDefault={refreshPagingDefault}
            sizeAllColumns={10}
          />
        </div>
      </CardBody>
    </Card>
  );
}

export default DataTableInvoice;
